<template>
  <div>
  <div class="booking-element booking-error">
    <div class="row" v-for="(err) in errors">
      <div class="booking-error--label column small-12 medium-3 large-3"><b>{{err.name}}</b></div>
      <div class="booking-error--message column small-12 medium-9 large-9">{{err.message}}</div>
    </div>
  </div>

  <div  class="booking-element text-center">
    <a class="cta cta--inverse cta--inline" @click="stepBack">Zurück</a>
  </div>
  </div>

</template>

<script>
export default {
  props: {
    errors: {
      type: Array,
      default: []
    }
  },
  methods: {
    stepBack(){
      this.$emit('step-back')
    }
  }
}
</script>

<style lang="scss" scoped>

</style>